<template>
    <div :class="getCSSClass('dropdown-button-container')">
        <button :class="getCSSClass('dropdown-button')" v-on:click="toggleMenu" :ref="'button'" :disabled="disabled">
            <span v-html="label" :class="getCSSClass('dropdown-button-label')"></span>
            <span v-html="caret"
                  :class="getCSSClass('dropdown-button-caret')"
                  style="transition: transform 150ms ease-in-out; transform-origin: center"
                  :style="{'transform': menuOpen ? 'rotate('+openRotation+')' : 'none'}"
            ></span>
        </button>
        <context-menu-component :subject="subject"
                                :show="menuOpen"
                                :cursorPosition="currentCursorPosition"
                                v-on:hide="menuOpen = false"
                                :selected="[]"
                                :menuitems="menuitems"
                                :revert-x-opening="revertXOpening"
                                v-on:context="$emit('context', $event)"
        ></context-menu-component>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            label: {type: String},
            caret: {type: String, default: '&#9666;'},
            menuitems: {type: Array},
            revertXOpening: {type: Boolean, default: false},
            openRotation: {type: String, default: '-90deg'},
            disabled: {type: Boolean, default: false}
        },
        data: function () {
            return {
                menuOpen: false,
                subject: {},
                currentCursorPosition: {x:0, y:0},
            }
        },
        mounted() {
        },
        methods: {
            toggleMenu: function(event) {
                event.stopImmediatePropagation();
                event.preventDefault();
                if (this.menuOpen) {
                    this.menuOpen = false;
                    return;
                }
                let bounding = this.$refs['button'].getBoundingClientRect();
                this.currentCursorPosition.x = bounding.x + bounding.width;
                this.currentCursorPosition.y = bounding.y + bounding.height + 10;
                this.menuOpen = true;
            }
        },
        computed: {},
        watch: {}

    }
</script>
